/**
 * formFieldContext —— 表单字段语义注入键（components 层共享，依赖方向：views → components）
 *
 * NextFormField（views 层）provide 字段 label 文案；BaseInput 等控件 inject 后
 * 在未显式传 aria-label 时兜底补全，使「标签 + 控件」对读屏软件可关联。
 * 无 provider 时 inject 兜底 null，控件行为与改动前完全一致（向后兼容）。
 */
import type { InjectionKey, Ref } from 'vue'

export const FORM_FIELD_LABEL_KEY: InjectionKey<Ref<string>> = Symbol('form-field-label')
